module.exports = new __parcel__URL__("x-mark.406cf679.svg").toString();